export default __webpack_public_path__ + "static/media/close-circle-mob.a63603b4.svg";